import {
  DRAGGABLE_TYPE,
  DROPZONE_TYPE,
} from '@components/ArtBoard/DragAndDrop/types'
import {
  ProjectActions,
  selectCompleteChildIds,
  selectDirectParentIds,
} from '@octopus-do/octopus-project-core'
import { thunkAddBlockAsSymbol } from '@store/migrationActions/thunkActions/thunkBlocksActions'
import { thunkPullLibrarySymbol } from '@store/migrationActions/thunkActions/thunkSymbolActions'
import { artBoardActions } from '@store/reducers/artboard'
import { COMMIT_PROJECT_REQUEST, MOVE_SYMBOL } from '@storeOld/actions'

import { isDirectRelative } from './utils'

// @TODO refactor
// @ts-expect-error
export const thunkDragStart = (payload) => (dispatch, getState) => {
  const { canvas, artboard, manager } = getState()

  if (
    payload.dragged.type === DRAGGABLE_TYPE.PAGE &&
    (!manager.meta.access.canEdit || artboard.isEmbed || artboard.isDisabled)
  ) {
    return
  }

  const draggedIds =
    payload.dragged.type === DRAGGABLE_TYPE.PAGE
      ? artboard.mode === 'seo_mode'
        ? []
        : canvas.node.selectedNodes
      : canvas[payload.dragged.type].ids

  dispatch(
    artBoardActions.dragStart({
      ...payload,
      dragged: {
        ...payload.dragged,
        ids: draggedIds,
      },
    })
  )
}

// @ts-expect-error
export const thunkDragStop = () => (dispatch, getState) => {
  const {
    artboard: { dragAndDrop },
    artboard,
    manager,
  } = getState()

  const draggedIds = [
    dragAndDrop.dragged.id,
    ...dragAndDrop.dragged.ids.filter(
      (id: string) => id !== dragAndDrop.dragged.id
    ),
  ]

  const dropZoneData = dragAndDrop.dropZone.data

  if (
    !dragAndDrop.isActive ||
    (dragAndDrop.dragged.type === DRAGGABLE_TYPE.PAGE &&
      (!manager.meta.access.canEdit ||
        artboard.isEmbed ||
        artboard.isDisabled)) ||
    draggedIds.includes(dragAndDrop.dropZone.id) ||
    !dropZoneData ||
    Object.keys(dropZoneData).length === 0
  ) {
    dispatch(artBoardActions.dragStop())

    return
  }

  if (dragAndDrop.dragged.type === DRAGGABLE_TYPE.PAGE) {
    const nextParentId =
      dragAndDrop.dropZone.type === DROPZONE_TYPE.PAGE
        ? dropZoneData.nodeId
        : dropZoneData.parentId
    const state = getState()
    const target = state.relations.dependencies[nextParentId]

    if (
      draggedIds.length === 1 &&
      dragAndDrop.dropZone.type === DROPZONE_TYPE.PAGE &&
      isDirectRelative(state, draggedIds[0], nextParentId)
    ) {
      dispatch({
        type: COMMIT_PROJECT_REQUEST,
        payload: [
          ProjectActions.nodes.swap({
            id: draggedIds[0],
            targetId: nextParentId,
          }),
        ],
      })
      dispatch(artBoardActions.dragStop())
      return
    }

    if (
      !target ||
      !['node', 'section'].includes(target.type) ||
      draggedIds.includes(nextParentId) ||
      draggedIds.some((id) => !state.relations.dependencies[id]) ||
      selectCompleteChildIds(draggedIds)(state).includes(nextParentId)
    ) {
      dispatch(artBoardActions.dragStop())
      return
    }

    if (dragAndDrop.dropZone.type === DROPZONE_TYPE.PAGE) {
      const parentsOfDraggedItems = selectDirectParentIds(draggedIds)(
        getState()
      )

      if (!parentsOfDraggedItems.includes(nextParentId)) {
        dispatch({
          type: COMMIT_PROJECT_REQUEST,
          payload: [
            ProjectActions.nodes.move({
              ids: draggedIds,
              nextParentId,
              index: 0,
            }),
          ],
        })
      }
    }

    if (dragAndDrop.dropZone.type === DROPZONE_TYPE.PAGE_NEXT) {
      const { childIndex } = dropZoneData

      dispatch({
        type: COMMIT_PROJECT_REQUEST,
        payload: [
          ProjectActions.nodes.move({
            ids: draggedIds,
            nextParentId,
            index: childIndex,
          }),
        ],
      })
    }
  }

  if (dragAndDrop.dragged.type === DRAGGABLE_TYPE.BLOCK) {
    if (dragAndDrop.dropZone.type === DROPZONE_TYPE.PAGE) {
      dispatch({
        type: COMMIT_PROJECT_REQUEST,
        payload: [
          ProjectActions.blocks.move({
            ids: draggedIds,
            index: 0,
            nextParentId: dropZoneData.nodeId,
          }),
        ],
      })
    }

    if (dragAndDrop.dropZone.type === DROPZONE_TYPE.BLOCK) {
      const { index, nodeId } = dropZoneData

      dispatch({
        type: COMMIT_PROJECT_REQUEST,
        payload: [
          ProjectActions.blocks.move({
            ids: draggedIds,
            index: index + 1,
            nextParentId: nodeId,
          }),
        ],
      })
    }
  }

  // A symbol dragged from the workspace library joins the project as a ref
  // first, then lands on the page like a project symbol would.
  if (
    dragAndDrop.dragged.type === DRAGGABLE_TYPE.SYMBOL &&
    dragAndDrop.dragged.data?.library
  ) {
    const isPageDrop =
      dragAndDrop.dropZone.type === DROPZONE_TYPE.BLOCK ||
      dragAndDrop.dropZone.type === DROPZONE_TYPE.PAGE

    if (isPageDrop) {
      const symbolId = dispatch(thunkPullLibrarySymbol(dragAndDrop.dragged.id))
      const index =
        dragAndDrop.dropZone.type === DROPZONE_TYPE.BLOCK
          ? dropZoneData.index + 1
          : 0

      if (symbolId) {
        dispatch(thunkAddBlockAsSymbol([symbolId], dropZoneData.nodeId, index))
      }
    }

    dispatch(artBoardActions.dragStop())

    return
  }

  if (dragAndDrop.dragged.type === DRAGGABLE_TYPE.SYMBOL) {
    if (dragAndDrop.dropZone.type === DROPZONE_TYPE.SYMBOL) {
      dispatch({
        type: COMMIT_PROJECT_REQUEST,
        payload: {
          type: MOVE_SYMBOL,
          payload: {
            symbolId: dragAndDrop.dragged.id,
            dragIndex: dropZoneData.index,
          },
        },
      })
    }

    if (dragAndDrop.dropZone.type === DROPZONE_TYPE.BLOCK) {
      dispatch(
        thunkAddBlockAsSymbol(
          draggedIds,
          dropZoneData.nodeId,
          dropZoneData.index + 1
        )
      )
    }

    if (dragAndDrop.dropZone.type === DROPZONE_TYPE.PAGE) {
      dispatch(thunkAddBlockAsSymbol(draggedIds, dropZoneData.nodeId, 0))
    }
  }

  dispatch(artBoardActions.dragStop())
}
